// import logo from "./logo.svg";
import "./App.css";
// import CustomCarousel from "./components/custom-carousel/CustomCarousel";
// import { useEffect, useState } from "react";
// import VideoModal from "./components/video-modal/VideoModal";
// import VideoModal_BS from "./components/video-modal/VideoModal_BS";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import Main from "./components/main/Main";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/work">
      <Route index element={<Main />} />
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
